<template>
  <div class="min-h-screen flex flex-col bg-white dark:bg-gray-950">
    <AppHeader />
    <div class="flex flex-1 container mx-auto px-4 py-6 gap-6">
      <AppSidebar />
      <main class="flex-1 min-w-0">
        <slot />
      </main>
    </div>
    <AppFooter />
  </div>
</template>
